import classNames from 'classnames'
import { StencilCDNImage } from '../StencilImage'
import Link from '../Link'
import { ListItemV3 } from './types/types'
import Text from '@/stories/components/Common/NewText'

const HeaderListItem = ({
  listElement,
  addClassNames,
  listItemClasses = '',
  onClose,
}: {
  listElement: ListItemV3
  addClassNames: string
  listItemClasses: string
  onClose: () => void
}) => {
  return (
    <div
      className={classNames('text-brand-grey-dark flex flex-col', {
        [addClassNames]: addClassNames,
      })}
    >
      {listElement.title && (
        <Text appearance="subtitle2" addClassName={`py-1 ${listItemClasses}`}>
          {listElement.title}
        </Text>
      )}
      {!!listElement.list?.length &&
        listElement.list.map((item, idx) => {
          return (
            <Link
              href={item.relative_path}
              key={idx}
              className={classNames(
                'hover:bg-brand-grey-background flex w-full flex-row items-center gap-3',
                {
                  [listItemClasses]: listItemClasses,
                },
              )}
              onClick={() => {
                onClose()
              }}
            >
              {item.img && (
                <StencilCDNImage
                  src={item.img}
                  alt={item.alt}
                  width={40}
                  height={40}
                />
              )}
              <Text appearance="body1" addClassName="w-full py-2">
                {item.text}
              </Text>
            </Link>
          )
        })}
    </div>
  )
}

export default HeaderListItem
